'use client';
import CustomLink from '@/components/custom-link';
import { usePathname } from 'next/navigation';

export const RequestQuoteBtn = () => {
  const pathname = usePathname();
  let buttonLabel = 'Get in Touch';
  let buttonHref = '/contact-us';

  if (pathname.includes('/contact-us')) {
    buttonLabel = 'Browse Services';
    buttonHref = '/services';
  }

  return (
    <CustomLink
      href={buttonHref}
      variant={'primary'}
      className="rounded-full bg-rm-secondary-100 px-4 py-2 text-[1rem] font-semibold text-white xl:text-[1.125rem]"
    >
      {buttonLabel}
    </CustomLink>
  );
};
